import { render, staticRenderFns } from "./ListCategoriasContas.vue?vue&type=template&id=4e3a0622&"
import script from "./ListCategoriasContas.vue?vue&type=script&lang=js&"
export * from "./ListCategoriasContas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports